import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Button, Image, Row } from 'components';
import styles from './styles.module.scss';
import { CompetitorDataType } from './allCompetitorDrawer';
import { useNavigate } from 'react-router-dom';
import { ADMIN_ROUTES } from 'constants/routes';

export type CompetitorBrandDataType = {
  name: string;
  files: Record<'LOGO', string>;
  id: string;
};

interface IExpandableBrandList {
  brands: CompetitorBrandDataType[];
  supplierName: string;
  supplierId: string;
  onExpand: (competitorSupplier: CompetitorDataType) => void;
}

export const ExpandableBrandList = (props: IExpandableBrandList) => {
  const { brands, supplierName, supplierId, onExpand } = props;
  const containerRef = useRef<HTMLDivElement>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const container = containerRef.current;
    if (container) {
      const rowHeight = 41; // Estimated height (38px + ~5px margin/padding)
      const rows = Math.round(container.scrollHeight / rowHeight);
      setIsOverflowing(rows > 2);
    }
  }, [brands]);

  const onRouteChange = useCallback(
    (id: string) => {
      navigate(`${ADMIN_ROUTES.brand.view}/${id}/management`);
    },
    [navigate]
  );

  return (
    <>
      <Row
        className={'gap-6'}
        ref={containerRef}
        style={{
          maxHeight: 82, // approx 2 rows of 38px height + gap
          overflow: 'hidden',
          flexWrap: 'wrap',
        }}
      >
        {brands.map((_brand: any) => (
          <Row key={_brand.id} className={styles.brand_name_box} align={'middle'}>
            {_brand.files?.LOGO && <Image preview={false} width={40} height={30} src={_brand.files?.LOGO} />}
            <Button
              type={'link'}
              variant={'link'}
              style={{
                color: '#525866',
                textDecoration: 'underline',
                padding: 0,
                margin: 0,
                fontSize: 14,
                fontWeight: 400,
              }}
              onClick={() => onRouteChange(_brand.id)}
            >
              {_brand.name}
            </Button>
          </Row>
        ))}
      </Row>
      {isOverflowing && (
        <Button
          type={'link'}
          variant={'link'}
          style={{
            color: '#308D82',
            textDecoration: 'underline',
            padding: 0,
            margin: 0,
            fontSize: 14,
            fontWeight: 400,
          }}
          onClick={() =>
            onExpand({
              supplierName,
              supplierId,
              brandData: brands,
            })
          }
        >
          See All
        </Button>
      )}
    </>
  );
};
